import { Alert } from "../../ui";
import { AlertType } from "../../ui/alert";

export function PricingVersionAlerts({
  pricingVersion,
  planLabel,
}: {
  pricingVersion: string | undefined;
  planLabel?: string | undefined;
}) {
  if (
    pricingVersion === "052024" ||
    (planLabel && !planLabel.toLowerCase().includes("legacy"))
  ) {
    return null;
  }
  return (
    <Alert title={`You are on a legacy plan`} type={AlertType.warning}>
      <p>
        It looks like you may have pricing override set due to being on a legacy
        plan, so the price shown might not be accurate. Please contact support
        for a quote and to change your number of accounts.
      </p>
      <p>
        <strong>
          Self-service changing plan or quota will change your plan to our new
          pricing
        </strong>{" "}
        - if you need to make changes please contact support.
      </p>
    </Alert>
  );
}
